<template>
  <div class="data-record">
    <div v-if="!isMobileView" class="user row row--hover box box--default">
      <div class="row__data row__data--small row__data--image" @click="goToAccountDetails()">
        <img v-if="userThumbnail" :src="userThumbnail" alt="" />
        <div v-else class="thumbnail thumbnail--user" :style="color">
          {{ parseInitials(user.first_name, user.last_name) }}
        </div>
      </div>
      <div class="row__data row__data--large row__data--name" @click="goToAccountDetails()">
        {{ user.first_name }} {{ user.last_name }}
      </div>
      <div class="row__data row__data--medium">
        <a class="row__phone icon__phone" :href="user.phone ? `tel:${user.phone}` : 'javascript:void(0)'"
          :class="{ 'icon__phone--active': user.phone }"></a>
        <a class="row__mail icon__mail" :href="user.email ? `mailto:${user.email}` : 'javascript:void(0)'"
          :class="{ 'icon__mail--active': user.email }"></a>
      </div>
      <div class="row__data row__data--large row__data--team">

        <VSelect v-if="teams && teams.length > 1" :options="teams" label="name"
          :getOptionLabel="(option) => option && typeof option === 'object' ? option.name || '' : ''"
          class="select select--default customer__dropdown" v-model="activeTeam"
          style="width: 100% !important; background-color: transparent !important; padding :0px !important; " />

        <div v-else-if="teams && teams.length == 1">
          <p style="color: var(--text-2);">{{ teams[0].name }}</p>
        </div>

        <span v-else>-</span>
      </div>
      <div class="row__data row__data--medium row__data--address" @click="goToAccountDetails()">
        {{ userAddress }}
      </div>
      <div class="row__data row__data--small row__data--zip" @click="goToAccountDetails()">
        {{ userZip }}
      </div>
      <div class="row__data row__data--medium row__data--city" @click="goToAccountDetails()">
        {{ userCity }}
      </div>
      <div class="row__data row__data--medium row__data--supervisor" @click="goToAccountDetails()">
        {{ supervisor }}
      </div>
      <div class="row__data row__data--large row__data--category" @click="goToAccountDetails()">
        <span>{{ saleCategory }}</span>
      </div>
      <div class="row__data row__data--small row__data--category" style="justify-content: center;">
        <div v-if="user.approved" class="icon icon__active"></div>
        <div v-else class="icon icon__inactive"></div>
      </div>
      <div v-if="hasRowActions" class="row__data row__data--action row__data--small"
        @click.self="showActionsDropdown = !showActionsDropdown">
        <RowActionDropdown v-if="showActionsDropdown" @toggleDropdown="showActionsDropdown = $event"
          :onEdit="canEdit ? editUser : null" :onDelete="canDelete ? removeUser : null"
          :isActive="canEdit ? Number(user.approved ? 1 : 0) : 0" :onDisable="canEdit ? disableTheUser : null"
          :onEnable="canEdit ? enableTheUser : null" />
      </div>


    </div>
    <article v-if="isMobileView" class="data-card box box--default">
      <header class="data-card__header">
        <button type="button" class="data-card__identity data-card__identity-full" @click="goToAccountDetails()">
          <span class="data-card__avatar">
            <img v-if="userThumbnail" :src="userThumbnail" :alt="user.first_name" />
            <span v-else class="thumbnail thumbnail--user" :style="color">
              {{ parseInitials(user.first_name, user.last_name) }}
            </span>
          </span>
          <span class="data-card__name data-card__name-flex">
            <span>{{ user.first_name }} {{ user.last_name }}</span>

            <div v-if="user.approved" class="icon icon__active"></div>
            <div v-else class="icon icon__inactive"></div>
          </span>
        </button>

        <div v-if="hasRowActions" class="data-card__action row__data--action" role="button"
          @click.self="showActionsDropdown = !showActionsDropdown">
          <RowActionDropdown v-if="showActionsDropdown" @toggleDropdown="showActionsDropdown = $event"
            :onEdit="canEdit ? editUser : null" :onDelete="canDelete ? removeUser : null"
            :isActive="canEdit ? Number(user.approved ? 1 : 0) : 0" :onDisable="canEdit ? disableTheUser : null"
            :onEnable="canEdit ? enableTheUser : null" />
        </div>
      </header>

      <div v-if="user.phone || user.email" class="data-card__contacts">
        <a v-if="user.phone" class="data-card__contact" :href="`tel:${user.phone}`">
          <span class="icon__phone--active"></span>
          <span>{{ user.phone }}</span>
        </a>
        <a v-if="user.email" class="data-card__contact" :href="`mailto:${user.email}`">
          <span class="icon__mail--active"></span>
          <span>{{ user.email }}</span>
        </a>
      </div>

      <dl class="data-card__details">
        <div class="data-card__detail data-card__detail-full">
          <dt>{{ $t(`users.${"tableHeader"}.${"team"}`) }}</dt>
          <dd>
            <VSelect v-if="teams && teams.length > 1" :options="teams" label="name"
              :getOptionLabel="(option) => option && typeof option === 'object' ? option.name || '' : ''"
              class="select select--default customer__dropdown" v-model="activeTeam"
              style="width: 100% !important; background-color: transparent !important; padding :0px !important; " />

            <div v-else-if="teams && teams.length == 1">
              <p>{{ teams[0].name }}</p>
            </div>
          </dd>
        </div>
        <div v-if="user.company_name" class="data-card__detail">
          <dt>{{ $t(`users.${"tableHeader"}.${"companyName"}`) }}</dt>
          <dd>{{ user.company_name }}</dd>
        </div>
        <div v-if="primaryAddress.street || primaryAddress.number" class="data-card__detail">
          <dt>{{ $t(`users.${"tableHeader"}.${"address"}`) }}</dt>
          <dd>
            <span v-if="primaryAddress.street" style="margin-right: 5px;">{{ primaryAddress.street }} </span>
            <span v-if="primaryAddress.number"> {{ primaryAddress.number }}</span>
          </dd>
        </div>
        <div v-if="userZip" class="data-card__detail">
          <dt>{{ $t(`users.${"tableHeader"}.${"zipCode"}`) }}</dt>
          <dd>{{ userZip }}</dd>
        </div>

        <div v-if="userCity" class="data-card__detail">
          <dt>{{ $t(`users.${"tableHeader"}.${"city"}`) }}</dt>
          <dd>{{ userCity }}</dd>
        </div>

        <div v-if="user.supervisor" class="data-card__detail">
          <dt>{{ $t(`users.${"tableHeader"}.${"supervisor"}`) }}</dt>
          <dd>{{ supervisor }}</dd>
        </div>

        <div v-if="saleCategory" class="data-card__detail">
          <dt>{{ $t(`users.${"tableHeader"}.${"salesGroup"}`) }}</dt>
          <dd>{{ saleCategory }}</dd>
        </div>
      </dl>
    </article>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import RowActionDropdown from "@/components/RowActionDropdown";
import statics from "@/statics";
import { parseInitials } from "@/helpers/entityParsers";

defineOptions({
  name: "User"
});

const props = defineProps({
  user: {
    required: true,
    type: Object,
  },
  deleteUser: {
    required: true,
    type: Function,
  },
  selectedTeamId: {
    type: Number,
    default: null,
  },
});

const store = useStore();
const router = useRouter();

// State
const showActionsDropdown = ref(false);
const activeTeam = ref(null);
const isMobileView = ref(false);

const updateMobileView = () => {
  isMobileView.value = window.innerWidth <= 900;
};


// Computed
const saleCategory = computed(() =>
  props.user.sales_category ? props.user.sales_category.name || statics.empty : statics.empty
);

const supervisor = computed(() =>
  props.user.supervisor ? props.user.supervisor.first_name + ' ' + props.user.supervisor.last_name : statics.empty
);

const userThumbnail = computed(() => props.user.photo ? props.user.photo.thumbnail : null);

const primaryAddress = computed(() =>
  Array.isArray(props.user.user_addresses) ? props.user.user_addresses[0] : null
);

const userAddress = computed(() => {
  if (!primaryAddress.value) return statics.empty;

  const street = primaryAddress.value.street?.trim();
  const number = primaryAddress.value.number?.trim();

  return street || number ? `${street || ""} ${number || ""}`.trim() : statics.empty;
});

const userZip = computed(() =>
  primaryAddress.value?.zip || statics.empty
);

const userCity = computed(() =>
  primaryAddress.value?.city || statics.empty
);

const color = computed(() =>
  props.user.color ? { background: props.user.color } : { background: "#7f8fa4" }
);

const teams = computed(() => {
  if (!Array.isArray(props.user.teams)) return [];

  return props.user.teams.map((team) => ({
    id: team.id,
    name: team.name,
  }));
});

// Get target user's team IDs as array
const userTeamIds = computed(() => 
  teams.value.map(team => team.id)
);

const isSuperAdmin = computed(() => store.getters.isSuperAdmin);

// NEW PERMISSION MODEL: Check if logged user can perform action on this user
// Requires: logged user and target user share a team where logged user has the permission
const canView = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.canPerformActionOnEntity("user_show", userTeamIds.value);
});

const canEdit = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.canPerformActionOnEntity("user_edit", userTeamIds.value);
});

const canDelete = computed(() => {
  if (isSuperAdmin.value) return true;
  return store.getters.canPerformActionOnEntity("user_delete", userTeamIds.value);
});

const hasRowActions = computed(() => canEdit.value || canDelete.value);

// Get the first common team where logged user can edit this user
const getEditTeamId = () => {
  if (isSuperAdmin.value) {
    return userTeamIds.value[0] ?? null;
  }

  const commonTeams = store.getters.getCommonTeamsWithPermission("user_edit", userTeamIds.value);
  const teamId = commonTeams.length > 0 ? commonTeams[0] : null;
  return teamId;
};

// Get the first common team where logged user can view this user
const getViewTeamId = () => {
  if (isSuperAdmin.value) {
    return userTeamIds.value[0] ?? null;
  }

  const commonTeams = store.getters.getCommonTeamsWithPermission("user_show", userTeamIds.value);
  const teamId = commonTeams.length > 0 ? commonTeams[0] : null;
  return teamId;
};

// Methods
const goToAccountDetails = () => { 
  
  if (!canView.value) { 
    return;
  }
  
  // Get the common team where logged user can view this user
  const teamId = getViewTeamId();
  
  const query = teamId !== null ? { team_id: teamId } : undefined;
  router.push({
    name: "AccountDetails",
    params: {
      entity: "user",
      id: props.user.id,
    },
    query,
  });
};

const editUser = () => { 
  
  if (!canEdit.value) { 
    return;
  }
  
  // Get the common team where logged user can edit this user
  const teamId = getEditTeamId();
  
  if (teamId === null) { 
    return;
  }
  
  store.commit("setUserToEdit", props.user.id);
  store.commit("setIsEdit", true);
  store.commit("setShowAddUserModal", true);
};

const removeUser = () => { 
  
  if (!canDelete.value) { 
    return;
  }
  
  // Get the common team where logged user can delete this user
  const commonTeams = isSuperAdmin.value
    ? userTeamIds.value
    : store.getters.getCommonTeamsWithPermission("user_delete", userTeamIds.value);
  const teamId = commonTeams.length > 0 ? commonTeams[0] : null;
  
  if (teamId === null) { 
    return;
  }
  
  props.deleteUser({
    display: true,
    message: `'${props.user.first_name}'`,
    action: () => store.dispatch("removeTeamMember", {
      teamId,
      userId: props.user.id,
    }),
    id: props.user.id,
  });
};

const disableTheUser = () => { 
  
  if (!canEdit.value) { 
    return;
  }
  
  // Verify team context - must share a team with edit permission
  const teamId = getEditTeamId();
  if (teamId === null) { 
    return;
  }
   
  store.dispatch("disableUser", props.user.id);
};

const enableTheUser = () => { 
  
  if (!canEdit.value) { 
    return;
  }
  
  // Verify team context - must share a team with edit permission
  const teamId = getEditTeamId();
  if (teamId === null) { 
    return;
  }
   
  store.dispatch("enableUser", props.user.id);
};

onMounted(() => {
  if (teams.value.length) {
    const { id, name } = teams.value[0];
    activeTeam.value = { id, name };
  }
  updateMobileView();
  window.addEventListener("resize", updateMobileView);
});

onBeforeUnmount(() => {
  window.removeEventListener("resize", updateMobileView);
});
</script>
<style scoped>
.row__data--zip {
  justify-content: center !important;
}

.row__data {
  line-break: anywhere;
}

.row__data--small .row__dropdown {
  width: 153.781px !important;
}
</style>
